import React from 'react';
import { Shield, Zap, Globe, Headphones } from 'lucide-react';
export function Features() {
  const features = [{
    icon: Shield,
    title: 'Paiements sécurisés',
    description: 'Vos transactions sont protégées par un chiffrement de niveau bancaire et la technologie Visa.'
  }, {
    icon: Zap,
    title: 'Transferts rapides',
    description: 'Vos paiements arrivent chez vos fournisseurs en quelques heures, pas en jours.'
  }, {
    icon: Globe,
    title: 'Sans frontières',
    description: "Payez vos fournisseurs en Chine, en Turquie et à Dubaï depuis la Côte d'Ivoire sans intermédiaire."
  }, {
    icon: Headphones,
    title: 'Support dédié',
    description: 'Notre équipe vous accompagne en français pour chaque transaction.'
  }];
  return <section id="features" className="py-20 bg-background" data-id="element-8">
      <div className="container mx-auto px-4 md:px-6" data-id="element-9">
        <div className="text-center mb-16" data-id="element-10">
          <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl mb-4" data-id="element-11">
            Pourquoi choisir CafaPay ?
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto" data-id="element-12">
            La solution conçue spécifiquement pour les besoins des importateurs
            ivoiriens.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4" data-id="element-13">
          {features.map((feature, index) => <div key={index} className="flex flex-col p-6 bg-card rounded-lg border border-border shadow-sm hover:shadow-md transition-shadow" data-id="element-14">
              <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-6 text-primary" data-id="element-15">
                <feature.icon className="h-6 w-6" data-id="element-16" />
              </div>
              <h3 className="text-lg font-bold text-foreground mb-3" data-id="element-17">
                {feature.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed" data-id="element-18">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}